// 过滤搜索数据(searchForm)
export default function searchFormFilter(data) {
  Object.keys(data).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    if (!data[key]) delete data[key];
  });
  return data;
}
